import { buildCzmlPackage } from './build_czml_package'

export const useAdsbLayer = (controller, { cesiumViewer, buttonGroup }) => {
  const adsbDataSource = new Cesium.CzmlDataSource('adsb-data-source')

  cesiumViewer.dataSources.add(adsbDataSource)

  const setupLayerToggle = () => {
    const adsbToggleInput = $('<input/>', { type: 'checkbox', id: 'adsb-layer-toggle', class: 'mr-2', checked: true })
    const adsbToggleLabel = $('<label/>', { class: 'cesium-button adsb-toggle-button', text: 'ADSB Aircraft' })

    adsbToggleLabel.prepend(adsbToggleInput)
    buttonGroup.append(adsbToggleLabel)

    // TODO: teardown the event listener when the controller is disconnected
    adsbToggleInput.on('change', (e) => {
      if (e.target.checked) {
        controller.showAdsbLayer()
      } else {
        controller.hideAdsbLayer()
      }
    })
  }

  Object.assign(controller, {
    showAdsbLayer () {
      adsbDataSource.show = true
    },

    hideAdsbLayer () {
      adsbDataSource.show = false
    },

    updateAdsb ({ detail }) {
      adsbDataSource.process(buildCzmlPackage(detail))
    }
  })

  setupLayerToggle()
}
